import { PRODUCTION, DEVELOPMENT, COMPLIANCE_DEV_URL } from "./const";
import { isEmpty } from "lodash";

export function ComplianceApiUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const API_URL = !!process.env.REACT_APP_COMPLIANCE_URL && process.env.REACT_APP_COMPLIANCE_URL !== "" ? process.env.REACT_APP_COMPLIANCE_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return COMPLIANCE_DEV_URL;
      case PRODUCTION:
        return API_URL;
      default:
        return COMPLIANCE_DEV_URL;
    }
  } else {
    return COMPLIANCE_DEV_URL;
  }
}

export const getComplianceApiUrl = (path) => {
  return `${ComplianceApiUrl()}${path}`;
};
